<template>
  <div>
    <project-one-confirm-sizing-modal :base-properties="baseProperties" />
    <project-one-save-modal :base-properties="baseProperties" />
    <project-one-summary-email-modal :base-properties="baseProperties" />
  </div>
</template>

<script>
import ProjectOneConfirmSizingModal from '@/projectOne/components/shared/ProjectOneConfirmSizingModal';
import ProjectOneSaveModal from '@/projectOne/components/shared/ProjectOneSaveModal';
import ProjectOneSummaryEmailModal from '@/projectOne/components/shared/ProjectOneSummaryEmailModal';

export default {
  components: {
    ProjectOneConfirmSizingModal,
    ProjectOneSaveModal,
    ProjectOneSummaryEmailModal,
  },
};
</script>
